module.exports = __webpack_public_path__ + "img/2024-02.c73ab635.jpg";